import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Images
import SNOW_FLAKE_IMG from "../../images/snowflake.png";

gsap.registerPlugin(ScrollTrigger);

function InfiniteScroll(props) {
  const { data: mstc } = props;

  useEffect(() => {
    // GSAP animation for #page1
    gsap.to("#page1", {
      x: () => window.innerWidth,
      rotation: 2 * 360, // Rotates by 360 degrees
      scrollTrigger: {
        trigger: "#page1", // Trigger for animation
        start: "bottom bottom", // Start animation when #page1's top reaches center of the viewport
        end: "bottom top", // End animation when #page1's bottom reaches the top of the viewport
        toggleActions: "restart pause reverse pause", // Animation toggles
        scrub: 1, // Smooth scrubbing
      },
    });
  }, []);

  return (
    <>
      <div style={{ marginTop: "16vh", marginBottom: "20vh" }}>
        <div style={{ overflow: "hidden" }}>
          <img
            id="page1"
            style={{ width: "180px", transform: "translate(-100%)" }}
            src={SNOW_FLAKE_IMG}
            alt="SNOW_FLAKE_IMG"
          />
        </div>
        <div id="page2">
          <div id="moving-text">
            <div className="con">
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
            </div>
            <div className="con">
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
            </div>
            <div className="con">
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
              <h1>&nbsp;{mstc}</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InfiniteScroll;
